import { render, staticRenderFns } from "./SwitchTimeZone.vue?vue&type=template&id=72dc0175&scoped=true&"
import script from "./SwitchTimeZone.vue?vue&type=script&lang=js&"
export * from "./SwitchTimeZone.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTimeZone.vue?vue&type=style&index=0&id=72dc0175&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc0175",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
